import config from 'configs';
import { Token } from '@kambria/kambria-contract';

/**
 * Documents
 * @default defaultData = {
 *  network: (string) network id
 *  account: (string) user address
 *  balance: (number) wei
 *  kat: (number) wei kat
 * }
 */

const defaultState = {
  network: null,
  account: null,
  balance: null,
  kat: null,
}

/**
 * Fetch blockchain info
 */
export const WATCH_INFO = 'WATCH_INFO';
export const WATCH_INFO_OK = 'WATCH_INFO_OK';
export const WATCH_INFO_FAIL = 'WATCH_INFO_FAIL';

const _watchEthereumToken = (address, callback) => {
  try {
    var { web3 } = window.kambriaWallet.provider;
    if (!web3) throw new Error('Cannot find web3 instance');
  } catch (er) {
    return callback('Cannot find web3 instance', null);
  }

  let token = new Token(config.eth.TOKEN.ADDRESS, web3);
  return token.watch(address).then(tokenWatcher => {
    tokenWatcher.event.on('data', re => {
      return callback(null, { kat: re.BALANCE });
    });
    tokenWatcher.event.on('error', er => {
      return callback(er, null);
    });
  }).catch(er => {
    return callback(er, null);
  });
}

const _watchInfo = (getState, callback) => {
  try {
    var { provider } = window.kambriaWallet;
    if (!provider) throw new Error('Kambria wallet is not registered');
  } catch (er) {
    console.error('Kambria wallet is not registered')
    return callback(null, { ...defaultState });
  }

  provider.watch((er, re) => {
    if (er) return callback(er, null);

    // Previous state
    let prevState = getState();

    if (prevState.blockchain.account !== re.account) {
      _watchEthereumToken(re.account, callback);
    }

    return callback(null, re);
  });
}

export const watchInfo = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      _watchInfo(getState, (er, re) => {
        dispatch({ type: WATCH_INFO });
        if (er) {
          dispatch({ type: WATCH_INFO_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: WATCH_INFO_OK, data: re });
        return resolve(re);
      });
    });
  }
}

/**
 * Reducder
 */
export default (state = { ...defaultState }, action) => {
  switch (action.type) {
    case WATCH_INFO_OK:
      return { ...state, ...action.data };
    case WATCH_INFO_FAIL:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
